// tslint:disable: no-bitwise

export enum RoleFlags {
  Member = 0,
  Admin = 1 << 0,
  SignDistributions = 1 << 1,
  SignCreateCreBank = 1 << 2,
}

/*

// https://stackoverflow.com/questions/39359740/what-are-enum-flags-in-typescript

To assign a flag to a variable:
--------------------------------
let features = RoleFlags.Admin;

To append another flag to the same variable:
--------------------------------------------
features |= RoleFlags.Admin;

To remove a flag from the variable:
--------------------------------------------
features &= ~RoleFlags.Admin;

Compare to check if a value is set in the variable:
---------------------------------------------------
console.log(RoleFlags.Admin === (features & RoleFlags.Admin)); // Return true
console.log(RoleFlags.SignDistributions === (features & RoleFlags.SignDistributions)); // Return false

*/

// tslint:disable-next-line:no-namespace
export namespace RoleFlags {
  export function toString(rf: RoleFlags): string {
    switch (rf) {
      case RoleFlags.Member:
        return "Member";
      case RoleFlags.Admin:
        return "Admin";
      case RoleFlags.SignDistributions:
        return "Distributions Signer";
      case RoleFlags.SignCreateCreBank:
        return "CRE bank account create Signer";
      default:
        return null;
    }
  }

  export function parse(str: string): RoleFlags {
    return RoleFlags[str];
  }

  export function isOn(
    featuresList: RoleFlags,
    valueToCheck: RoleFlags
  ): boolean {
    return valueToCheck === (featuresList & valueToCheck);
  }
}

export default RoleFlags;
